





































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import {
  EventPostStatus,
  isEventNotificationDetails,
} from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import { getLiveUrl, getProfileUrl } from "@/lib/urlHelpers";
import router from "@/router";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationEventPublished",
  components: { ScreenNamePrinter, NotificationItemView, BaseIcon, BaseButton },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const isEventSet = computed<boolean>(() => {
      return isEventNotificationDetails(props.notification.details);
    });

    const isPublished = computed<boolean>(() => {
      return props.notification.type === NotificationType.EVENT_PUBLISHED;
    });

    const isStarted = computed<boolean>(() => {
      return props.notification.type === NotificationType.EVENT_STARTED;
    });

    const isCancelled = computed<boolean>(() => {
      return props.notification.type === NotificationType.EVENT_CANCELLED;
    });

    const showPostIcon = computed<boolean>(() => {
      return (
        (props.notification.type === NotificationType.EVENT_PUBLISHED ||
          props.notification.type === NotificationType.EVENT_CANCELLED) &&
        (props.notification.details.event.status === EventPostStatus.PUBLISHED ||
          props.notification.details.event.status === EventPostStatus.READY_TO_START ||
          props.notification.details.event.status === EventPostStatus.STARTED ||
          props.notification.details.event.status === EventPostStatus.CANCELLED)
      );
    });

    const showStartedIcon = computed<boolean>(() => {
      return (
        props.notification.type === NotificationType.EVENT_STARTED &&
        (props.notification.details.event.status === EventPostStatus.READY_TO_START ||
          props.notification.details.event.status === EventPostStatus.STARTED)
      );
    });

    const subjectUrl = computed<Location>(() => {
      if (isEventSet.value) {
        return getProfileUrl(props.notification.user?.id ?? "", { feedId: props.notification.details.event.postId });
      }
      return getProfileUrl(props.notification.user?.id ?? "");
    });

    const goLive = () => {
      if (props.notification.user) {
        const liveUrl = getLiveUrl(props.notification.user);
        router.push(liveUrl);
      }
    };

    return {
      subjectUrl,
      isPublished,
      isStarted,
      isCancelled,
      showPostIcon,
      showStartedIcon,
      goLive,
    };
  },
});
